import { Injectable} from '@angular/core';
import { SignalService } from '@app/fremework/signal.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SnackService extends SignalService<string> {

  constructor() {
    super();
  }

  public snackMessages$(): Observable<string> {
    return this.obervableSignal$
  }

  public showSnackBar(message: string): void {
    this.pushSignalReset(message);
  }


}
